import { render, staticRenderFns } from "./PackagePlanAdj.vue?vue&type=template&id=bfa09a70&"
import script from "./PackagePlanAdj.vue?vue&type=script&lang=js&"
export * from "./PackagePlanAdj.vue?vue&type=script&lang=js&"
import style0 from "./PackagePlanAdj.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackagePlanAdj.vue"
export default component.exports